/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import LoadingPage from '../../pages/LoadingPage';
import { maskPercent } from '../../utils/masks';

const AttendancePresencialReportTableList = ({ listItem = null }) => {

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nome do cliente</TableCell>
              <TableCell>Loja/Concessionária</TableCell>
              <TableCell>Nome do corretor</TableCell>
              <TableCell>Data/Hora do atendimento</TableCell>
              <TableCell>Data/Hora da cotação</TableCell>
              <TableCell>Mandou a cotação por onde?</TableCell>
              <TableCell>Vendido ou não vendido</TableCell>
              <TableCell>Recebeu a proposta por onde?</TableCell>
              <TableCell>Data/hora finalização do lead</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem &&
              listItem?.map((item) => (
                <TableRow key={item?.id}>
                  <TableCell align="left">{item?.id}</TableCell>
                  <TableCell align="left">{item?.client}</TableCell>
                  <TableCell align="left">{item?.partner}</TableCell>
                  <TableCell align="left">{item?.broker}</TableCell>
                  <TableCell>{item?.contact_date}</TableCell>
                  <TableCell>{item?.quoted_date}</TableCell>
                  <TableCell>{item?.quoted_type}</TableCell>
                  <TableCell>{item?.sold}</TableCell>
                  <TableCell>{item?.sold_type}</TableCell>
                  <TableCell>{item?.end_lead}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AttendancePresencialReportTableList;
